import { TABS } from "./NotificationContext";

export const NOTIFICATIONS_PER_PAGE = 15;
export const MIN_TABS_CONTAINER_WIDTH = 478;
export const MIN_TABS_CONTAINER_WIDTH_V2 = 528;

export const getFetchNotificationQueryKey = (
  notificationGroup: string,
  filter?: string,
) => ["notifications", filter, notificationGroup];

/**
 * Maps notification tab keys to the corresponding counter field names
 * returned by the notifications count API. Shared between the desktop
 * Body component and the mobile useNotificationSectionTabs hook.
 */
export const NOTIFICATION_COUNTER_KEY_MAP: Partial<
  Record<(typeof TABS)[keyof typeof TABS], string>
> = {
  [TABS.INBOX]: "new_inbox_count",
  [TABS.MENTIONS]: "new_mentions_count",
  [TABS.CONTENT]: "new_content_count",
  [TABS.MODERATION]: "new_moderation_count",
};
